import type { ScenarioBudget, TagRevenu, ChangementRevenu } from './index';

// ── Module Charges d'exploitation ───────────────────────────────────────────
// Le numéro de compte est nu : l'imputation analytique (prestation et/ou site)
// remplace les suffixes -CCC/-ANT/-ENM du plan comptable. Montants signés.

export interface CelluleCharge {
  mois: number;
  montant: number;
  tag: TagRevenu | null;
  moisEffet: string | null; // mois_effet de l'événement en vigueur (report = prévision)
  changement: ChangementRevenu | null;
}

export interface EvenementCharge {
  id: number;
  mois_effet: string;
  montant: number;
  tag: TagRevenu;
  scenario_id: number | null;
  commentaire: string;
}

export interface LigneCompte {
  id: number;
  numero: string;
  libelle: string;
  note: string | null;
  rubriqueId: number;
  rubriqueCode: string;
  rubriqueLibelle: string;
  classe: string;
  prestationId: number | null;
  prestationLibelle: string | null;
  siteId: number | null;
  siteNom: string | null;
  actif: boolean;
  mois: CelluleCharge[];
  totalAnnuel: number;
  aProjections: boolean;
  evenements: EvenementCharge[];
}

export interface SousTotalRubrique {
  code: string;
  libelle: string;
  classe: string;
  parMois: number[];
  annuel: number;
}

export interface GrilleCharges {
  annee: number;
  scenario: 'definitif' | number;
  comptes: LigneCompte[];
  sousTotaux: SousTotalRubrique[];
  totauxMensuels: number[];
  totalAnnuel: number;
  scenarios: ScenarioBudget[];
}

export interface RubriqueCharge {
  id: number;
  code: string;
  libelle: string;
  classe: string;
  ordre: number;
}

export const CLASSES_LABELS: Record<string, string> = {
  materiel: 'Charges de matériel des prestations',
  exploitation: 'Autres charges d’exploitation',
  amortissement: 'Amortissements',
  financier: 'Charges et produits financiers',
  exceptionnel: 'Résultats exceptionnels et hors exploitation',
};
